import { withNamespaces } from "react-i18next";
import Accordion from 'react-bootstrap/Accordion';
import ShareholdersImage from "src/modules/3rd-party-management/assets/images/shareholders.svg";
import { Table } from "reactstrap";
import {
    hasNonEmptyArray,
    parseHandelsregisterOrganizationData
} from "../../helpers";

const formatPct = (value) => {
    if (value === null || value === undefined || value === '') {
        return '-';
    }
    const num = Number(value);
    if (Number.isNaN(num)) {
        return String(value);
    }
    return `${num.toFixed(2)}%`;
};

const Ubos = ({
    t,
    activeAccordion,
    setActiveAccordion,
    detailsQuery
}) => {
    const data = parseHandelsregisterOrganizationData(detailsQuery?.data?.company);
    const owners = data?.ubos?.beneficial_owners || [];
    const unresolved = data?.ubos?.unresolved_beneficial_owners || [];

    if (!hasNonEmptyArray(owners) && !hasNonEmptyArray(unresolved)) {
        return null;
    }

    return (
        <Accordion.Item
            onClick={() => setActiveAccordion('ubos')}
            className={activeAccordion === 'ubos' ? 'active' : ''}
            eventKey={'ubos'}
        >
            <Accordion.Header>
                <img src={ShareholdersImage} alt="" />
                <span>{t('Ultimate Beneficial Owners (UBOs)')}</span>
            </Accordion.Header>

            <Accordion.Body>
                {hasNonEmptyArray(owners) && (
                    <div className="mb-4">
                        <h6 className="mb-3">{t('Beneficial Owners')}</h6>
                        <div className="table-responsive">
                            <Table bordered hover striped size="sm" className="mb-0">
                                <thead>
                                    <tr>
                                        <th>{t('Name')}</th>
                                        <th>{t('Date of Birth')}</th>
                                        <th>{t('City')}</th>
                                        <th>{t('Ownership')}</th>
                                        <th>{t('Path')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {owners.map((owner, index) => {
                                        const person = owner.person || {};
                                        const path = (owner.paths || [])
                                            .map((p) => (p.via || []).map((v) => v.name).filter(Boolean).join(' → '))
                                            .filter(Boolean)
                                            .join('; ');

                                        return (
                                            <tr key={person.entity_id || index}>
                                                <td>{person.name || '-'}</td>
                                                <td>{person.birth_date || '-'}</td>
                                                <td>{person.location?.home?.city || '-'}</td>
                                                <td>{formatPct(owner.ownership_percentage)}</td>
                                                <td>{path || '-'}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                )}

                {hasNonEmptyArray(unresolved) && (
                    <div>
                        <h6 className="mb-3">{t('Unresolved Beneficial Owners')}</h6>
                        <div className="table-responsive">
                            <Table bordered hover striped size="sm" className="mb-0">
                                <thead>
                                    <tr>
                                        <th>{t('Name')}</th>
                                        <th>{t('Legal Form')}</th>
                                        <th>{t('Ownership')}</th>
                                        <th>{t('Reason')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {unresolved.map((item, index) => (
                                        <tr key={item.entity_id || index}>
                                            <td>{item.name || '-'}</td>
                                            <td>{item.legal_form || '-'}</td>
                                            <td>{formatPct(item.ownership_percentage)}</td>
                                            <td>{item.reason || '-'}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </div>
                )}
            </Accordion.Body>
        </Accordion.Item>
    );
};

export default withNamespaces()(Ubos);
